import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgFormatUnderline = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 17"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M7.996 14.254q1.545 0 2.67-.599a4.2 4.2 0 0 0 1.725-1.663Q13 10.918 13 9.514V1.832q0-.375-.223-.6-.215-.231-.584-.232a.75.75 0 0 0-.575.233q-.206.223-.206.599V9.38q0 1.494-.901 2.424-.902.93-2.515.93-1.074 0-1.837-.42a2.9 2.9 0 0 1-1.168-1.181q-.403-.75-.403-1.753V1.832q0-.375-.223-.6Q4.15 1.002 3.78 1a.75.75 0 0 0-.575.233Q3 1.456 3 1.832v7.682q0 1.404.6 2.478a4.27 4.27 0 0 0 1.726 1.663q1.125.6 2.67.6M3.506 17h8.979a.48.48 0 0 0 .36-.152.5.5 0 0 0 .155-.376.52.52 0 0 0-.155-.384.48.48 0 0 0-.36-.152H3.506a.5.5 0 0 0-.36.152.53.53 0 0 0-.146.384q0 .225.146.376a.5.5 0 0 0 .36.152"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFormatUnderline);
export default ForwardRef;
